/**
 * JSON Schema Lookup Utility
 *
 * Provides easy access to JSON schemas for individual config settings.
 * Loads the generated JSON schema file and provides a lookup function.
 */

// Import JSON schema directly - TypeScript's resolveJsonModule handles this
import jsonSchema from '../_generated/config.schema.json'

type JsonSchema = Record<string, unknown>

/**
 * Loads the generated JSON schema file.
 * Returns the cached schema object.
 */
function loadJsonSchema(): { properties?: Record<string, JsonSchema> } {
  return jsonSchema as { properties?: Record<string, JsonSchema> }
}

/**
 * Gets the JSON schema for a specific config setting.
 *
 * @param settingKey - The key of the config setting (e.g., 'api_enabled')
 * @returns The JSON schema object for the setting, or undefined if not found
 */
export function getJsonSchemaForSetting(settingKey: string): JsonSchema | undefined {
  const schema = loadJsonSchema()
  return schema.properties?.[settingKey]
}

